import React from "react";
import TransactionHistory from "./TransactionHistory";

const BetMenu = ({ selected, setSelected, onTransactionHistoryClick }) => {
  const handleTxHistoryClick = () => {
    setSelected("history");
    if (onTransactionHistoryClick) {
      onTransactionHistoryClick();
    }
  };

  return (
    <div className="w-full">
      <ul className="w-full xl:text-base xs:text-[14px] text-xs flex 2xl:pt-4 pt-3 font-redHat font-bold items-center">
        <li
          role="button"
          aria-label="Bet"
          onClick={() => setSelected("bet")}
          className={`cursor-pointer text-[#dbdbdb] transition-all duration-[250ms] ease w-full 2xl:py-4 py-2 text-center xs:border-b-2 border-b ${
            selected === "bet" ? "  border-b-[#200052]" : "border-[#1f1f1f]"
          } `}
        >
          Bet
        </li>
        <li
          role="button"
          aria-label="Transaction History"
          onClick={handleTxHistoryClick}
          className={`cursor-pointer text-[#dbdbdb] transition-all duration-[250ms] ease w-full 2xl:py-4 py-2 text-center border-b-2 ${
            selected === "history" ? " border-b-[#200052]" : "border-[#1f1f1f]"
          } `}
        >
          Tx History
        </li>
      </ul>
    </div>
  );
};

export default BetMenu;
